module.exports = ".btn-light {\n  text-transform: capitalize; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/advanced-search/search.component.scss
// module id = ./src/app/shared/advanced-search/search.component.scss
// module chunks = main